
// SAU - one column (2 1/16 inch) wide , with 1/8 inch gutter between columns.
// calculated = [2.063, 4.25, 6.438, 8.625, 10.813, 13]
// from MiAD which rounds .0005 down
import {indexOf, isNaN} from "lodash";
import * as utils from "../lib/Utils";

export const SAU = [2.062, 4.25, 6.437, 8.625, 10.812, 13];

//PASS - one column (1 5/6 inch) wide , with 1/8 inch gutter between columns.
export const PASS = [1.833, 3.792, 5.75, 7.708, 9.667, 11.625];


// default gives SAU
// todo rounds final 5 up?
/*
function getColumnsSizes(col=33,colDiv=16, gap=32, gapDiv=16, numCols=6, decimals=3) {
    return [...Array(numCols)].map((i, c) => round((c + 1) * col / colDiv + c * gap / gapDiv, decimals));
}

function getColSize(numCol, col=33,colDiv=16, gap=32, gapDiv=16, decimals=3) {
    return round(numCol * col / colDiv + (numCol-1) * gap / gapDiv, decimals);
}
*/

//todo rename
export const columnSizes = {SAU, PASS};


// take an ordered  list like PASS and return the index of the closet entry to value
// Used to coalesce a custom vale into a standard number of columns
export const getIndexOfClosest = (value, set, defaultIndex=2)=>{
    // should only get default if value undefined
    //return set.reduce((a,c)=>Math.abs(value-c) < Math.abs(value-a) ? c : a, set[1]);
    return set.reduce((a,v,i)=>Math.abs(value-v) < Math.abs(value-set[a]) ? i : a, defaultIndex);
};



export const getStandardColumns = (width, sets= ['PASS','SAU'], noneName='custom' )=>{

    const newWidth = utils.round(width,3);
    let result = {standard:noneName, columns:0};

    if (!isNaN(newWidth)) {

        let i = 0;
        while (result.columns===0 && i < sets.length) {
            const standard = sets[i];
            const index = indexOf(columnSizes[standard], newWidth);
            if (index > -1) {
                result = {standard, columns: index+1};
            }
            i++;
        }
    }

    return result;
};